export enum NotificationChannelEnum {
  email = 'email',
  inApp = 'inApp',
  system = 'system',
}
